/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getPortfolioById } from '../actions/portfolio-tracker';
import { Portfolio } from '../types/portfolio';

interface SliceState {
  data?: Portfolio;
  id?: string;
  errorMessage: string;
  errored: boolean;
  loaded: boolean;
  loading: boolean;
}
const createState = (): SliceState => ({
  data: undefined,
  id: undefined,
  errorMessage: '',
  errored: false,
  loaded: false,
  loading: false,
})

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState: createState(),
  reducers: {
    load: (state, action: PayloadAction<string>) => ({ ...state, id: action.payload, loaded: false, loading: true }),
    reload: (state) => ({ ...state, loading: true }),
    loaded(state, action: PayloadAction<Portfolio>) {
      return { ...state, data: action.payload, loaded: true, loading: false };
    },
    handleError(state, action: PayloadAction<string>) {
      return {
        ...state,
        loaded: true,
        loading: false,
        errored: true,
        errorMessage: action.payload
      };
    },
  }
});

const { load, reload, loaded, handleError } = portfolioSlice.actions

export const loadPortfolioById = (portfolioId: string) => (dispatch: any, getState: () => any) => {
  const sliceState: SliceState = getState()[portfolioSlice.name];
  if (sliceState.loaded || sliceState.loading) {
    if (sliceState.id === portfolioId) {
      return;
    }
  }
  dispatch(load(portfolioId));

  getPortfolioById(portfolioId)
    .then((data) => {
      dispatch(loaded(data))
    })
    .catch((e) => handleError(e));
}

export const reloadPortfolioById = (portfolioId: string, flagReload: boolean = false) => (dispatch: any, getState: () => any) => {
  const sliceState: SliceState = getState()[portfolioSlice.name];
  if (sliceState.loading) {
    return;
  }

  if (flagReload) {
    dispatch(reload());
  }

  getPortfolioById(portfolioId)
    .then((data) => {
      dispatch(loaded(data))
    })
    .catch((e) => handleError(e));
}

export default portfolioSlice.reducer
